import axios from "axios";
import state from "../store";

let baseUrl = state.getters.mainAppURL + "firestore_restaurant/";

const getRestaurantQRAnalytics = (params) =>  axios.get(`${baseUrl}?${params}`);
const getScansOverTimeAnalytics = (params) =>  axios.get(`${baseUrl}scans_over_time?${params}`);

export {
    getRestaurantQRAnalytics,
    getScansOverTimeAnalytics
}